import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleSynopsis',
  props: {
    shortDescription: { default: '' },
    originalShortDescription: { default: '' },
    showSubheading: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { shortDescription: string, originalShortDescription: string, showSubheading: boolean };



const showOriginal = ref(false);

const synopsis = computed<string>(() => (showOriginal.value ? props.originalShortDescription : props.shortDescription));

return { __sfc: true,props, showOriginal, synopsis }
}

})